import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/adminapi/login',
    method: 'post',
    data
  });
}

export function getSwitchEnt(data) {
  return request({
    url: '/adminapi/login/switch_ent',
    method: 'put',
    data
  });
}

export function logOut() {
  return request({
    url: '/adminapi/loginout',
    method: 'post'
  });
}
export function getMyDeptList() {
  return request({
    url: '/adminapi/structure/v2/listDeptFullPathByUid',
    method: 'get'
  });
}

export function saveSwitchDept(data) {
  return request({
    url: '/adminapi/switch/department',
    method: 'post',
    data
  });
}
